import * as React from 'react'

export const DownArrowIcon = ({
  onClick,
}: {
  onClick?: React.MouseEventHandler<SVGSVGElement>
}) => {
  return (
    <svg
      width='14'
      height='8'
      viewBox='0 0 14 8'
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
    >
      <path
        d='M7.49686 6.95895L7.00366 7.39899L0.202742 1.3417C-0.065835 1.10242 -0.0693235 0.705895 0.202742 0.463505C0.26733 0.405548 0.344142 0.359539 0.428759 0.328123C0.513376 0.296707 0.60413 0.280505 0.6958 0.280447C0.787471 0.280389 0.87825 0.296477 0.962917 0.327786C1.04758 0.359096 1.12447 0.405008 1.18915 0.462883L7.00226 5.63948L12.8105 0.462262C12.8751 0.404365 12.9519 0.358417 13.0364 0.327063C13.121 0.295708 13.2117 0.279567 13.3033 0.279567C13.395 0.279567 13.4857 0.295708 13.5703 0.327063C13.6548 0.358417 13.7316 0.404365 13.7962 0.462262C13.9265 0.578969 13.9997 0.736814 14 0.901417C14.0003 1.06602 13.9275 1.22405 13.7976 1.34108L7.52407 6.93285L7.49616 6.95833L7.49686 6.95895Z'
        fill='#999999'
      />
    </svg>
  )
}
